export default "__VITE_ASSET__2fb62e85__"